import React, { useCallback, useEffect, useState } from "react";
import { ElectionNews, Loader, MaskedInput, UnAuth } from "../components";
import { FaCheck } from "react-icons/fa6";
import {
  checkMembershipNoLength,
  get,
  getElectionNews,
  getGenderFromCode,
  isNotNullOrEmpty,
  post,
} from "../functions";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import parse from "html-react-parser";

const membershipObj = {
  type: "NIC",
  number: "",
};
const errorObj = {
  notFound: "",
  customMessage: "",
  number: false,
};
const memberObj = {
  Person_ID: 0,
  Name: "",
  Father_Husband_Name: "",
  JID: "",
  JCIC: "",
  NIC: "",
  Surname: "",
  Gender: "",
  Age: "",
  Remarks: "",
  Message: "",
};

const ElectoralSearch = () => {
  const [unauth, setUnAuth] = useState(false);
  const [error, setError] = useState(errorObj);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [electionConfig, setElectionConfig] = useState({
    electionEntity: "",
    electionYear: "",
    electionType: "",
    electoralSearchHeading: "",
  });
  const [membership, setMembership] = useState(membershipObj);
  const [member, setMember] = useState(memberObj);
  const [electionNews, setElectionNews] = useState({
    text: "",
    imageUrl: "",
    createdBy: {},
    styles: {},
  });
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha("yourAction");
    const response = await post(
      `https://recaptchaenterprise.googleapis.com/v1/projects/kpsiajapp/assessments?key=${process.env.REACT_APP_API_KEY}`,
      {
        event: {
          token: token,
          expectedAction: "LOGIN",
          siteKey: process.env.REACT_APP_RECAPTCHA_KEY,
        },
      },
      "other"
    );
    if (response.status === "success") {
      setElectionNews(response.data);
    }
  }, [executeRecaptcha]);

  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  const getElectionConfig = async () => {
    const response = await get("/public/electoral-roll/config");
    if (response?.status === "Success") {
      response.data.map(({ code, value }) => {
        electionConfig[code] = value;
      });
      setElectionConfig({ ...electionConfig });
    }
  };

  const getLookups = async () => {
    await getElectionNews(setElectionNews);
    await getElectionConfig();
    setLoading(false);
  };

  useEffect(() => {
    getLookups();
  }, []);

  const searchMember = async (e) => {
    e.preventDefault();

    let valid = checkMembershipNoLength(membership.type, membership.number);
    setError({ ...error, number: valid });

    if (!valid) {
      setSearchLoading(true);
      const response = await post("/public/electoral-roll", {
        doctype: membership.type,
        docno: membership.number,
      });
      if (response?.status === "Success") {
        setMember({ ...response.data, Message: response.message });
        setError(errorObj);
      } else if (
        response?.status === "Error" &&
        response?.message === "Member not found"
      ) {
        setError({
          number: false,
          notFound: response?.message,
          customMessage: response?.data?.custom_message,
        });
        setMember(memberObj);
      } else if (
        response?.status === "Error" &&
        response?.message === "Unauthorized access."
      ) {
        setUnAuth(true);
      }
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    if (isNotNullOrEmpty(membership.type)) {
      setMember(memberObj);
      setMembership({
        ...membership,
        number: "",
      });
      setError(errorObj);
    }
  }, [membership.type]);

  const checkedButton = (key) => {
    let condition = membership.type === key;
    let bgColor =
      (condition ? "flex items-center bg-brown text-white" : "bg-grey") +
      " *:appearance-none";
    return { bgColor, icon: condition };
  };

  if (unauth) {
    return <UnAuth />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <main className="gap-8 !p-10 grid grid-cols-1 md:grid-cols-[37%_60%]">
      <section className="flex flex-col w-full max-w-[400px] mx-auto pt-5">
        <h1 className="heading !mb-1">
          {electionConfig.electionEntity} {electionConfig.electionYear}
        </h1>
        <h2 className="heading">({electionConfig.electionType})</h2>
        <h2 className="heading">Electoral Roll Search</h2>
        <form onSubmit={searchMember}>
          <section className="flex justify-between *:px-2 *:py-1 *:rounded-full *:font-medium *:cursor-pointer">
            <label htmlFor="NIC" className={checkedButton("NIC").bgColor}>
              <input
                id="NIC"
                type="radio"
                name="type"
                checked={membership.type === "NIC"}
                onChange={() => setMembership({ ...membership, type: "NIC" })}
              />{" "}
              {checkedButton("NIC").icon && <FaCheck className="mr-1" />}
              CNIC #
            </label>
            <label htmlFor="JCIC" className={checkedButton("JCIC").bgColor}>
              <input
                id="JCIC"
                type="radio"
                name="type"
                checked={membership.type === "JCIC"}
                onChange={() => setMembership({ ...membership, type: "JCIC" })}
              />{" "}
              {checkedButton("JCIC").icon && <FaCheck className="mr-1" />}
              JCIC #
            </label>
            <label htmlFor="JID" className={checkedButton("JID").bgColor}>
              <input
                id="JID"
                type="radio"
                name="type"
                checked={membership.type === "JID"}
                onChange={() => setMembership({ ...membership, type: "JID" })}
              />{" "}
              {checkedButton("JID").icon && <FaCheck className="mr-1" />}
              JID #
            </label>
          </section>
          <br />
          <MaskedInput
            stateKey="number"
            type={membership.type}
            state={membership}
            setState={setMembership}
            error={error.number}
          />
        </form>
        {searchLoading ? (
          <Loader withoutImg={true} />
        ) : (
          <React.Fragment>
            {member.Person_ID !== 0 && (
              <React.Fragment>
                <section className="section border-[1px] border-brown !w-full mt-8 !p-5">
                  <h2 className="mt-0.5 text-xl text-center">
                    {member.Name} {member.Father_Husband_Name}
                  </h2>
                  <p className="font-medium">
                    CNIC: <span>{member.NIC}</span>
                    <br />
                    JCIC: <span>{member.JCIC}</span>
                    {isNotNullOrEmpty(member.JID) && (
                      <React.Fragment>
                        <br />
                        JID: <span>{member.JID}</span>
                      </React.Fragment>
                    )}
                    <br />
                    Surname: <span>{member.Surname}</span>
                    <br />
                    Age: <span>{member.Age}</span>
                    <br />
                    {isNotNullOrEmpty(member.Gender) && (
                      <React.Fragment>
                        Gender: <span>{getGenderFromCode(member.Gender)}</span>
                      </React.Fragment>
                    )}
                  </p>
                </section>
                <div className="mt-8 text-emerald-600 font-medium">
                  {parse(member.Message)}
                </div>
              </React.Fragment>
            )}
            {isNotNullOrEmpty(error.notFound) && (
              <section className="section border-[1px] border-brown !w-full mt-8 !py-10 !px-5">
                <h2 className="!mb-0 text-xl text-center">{error.notFound}</h2>
                {isNotNullOrEmpty(error.customMessage) && (
                  <p className="mt-5">{parse(error.customMessage)}</p>
                )}
              </section>
            )}
          </React.Fragment>
        )}
      </section>
      <ElectionNews electionNews={electionNews} />
    </main>
  );
};

export default ElectoralSearch;
